import React from 'react';

const SIZES = { sm: 32, md: 40, lg: 56 };

/**
 * Avatar — circular initials or logo. Green-tinted by default; pass `src` for an image.
 */
export function Avatar({ name = '', src, size = 'md', tone = 'green', style = {}, ...rest }) {
  const dim = SIZES[size] || SIZES.md;
  const initials = name.split(' ').filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase();
  const tones = {
    green: { bg: 'var(--brand-green-soft)', color: 'var(--brand-green)' },
    blue: { bg: 'var(--accent-blue-soft)', color: 'var(--accent-blue)' },
    solid: { bg: 'var(--brand-green)', color: '#fff' },
    slate: { bg: 'var(--surface-2)', color: 'var(--text-muted)' },
  };
  const t = tones[tone] || tones.green;
  return (
    <div style={{
      width: dim, height: dim, borderRadius: 999, flexShrink: 0,
      background: src ? 'transparent' : t.bg, color: t.color,
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
      fontFamily: 'var(--font-sans)', fontWeight: 800, fontSize: dim * 0.36, ...style,
    }} {...rest}>
      {src ? <img src={src} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
    </div>
  );
}
